import React from 'react';
import { RiderDetailInfo } from '../types/riderInfoDetail.types';
import '../styles/BasicInfoSection.css';
import {
    BASIC_INFO_LEFT_FIELDS,
    BASIC_INFO_RIGHT_FIELDS,
    getDisplayValue,
    formatSettlementDate,
} from '../utils/riderInfoDetailHelpers';
import { getPreAccountBadgeText } from '@/shared/utils/accountingLabelHelpers';

interface BasicInfoSectionProps {
    riderInfo: RiderDetailInfo;
}

const SETTLEMENT_KEYS = new Set(['currentSettlement', 'nextSettlement']);

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ riderInfo }) => {
    const renderFieldValue = (key: string): string => {
        if (key === 'preAcctYn') {
            return getPreAccountBadgeText(riderInfo.preAcctYn || null);
        }
        if (key === 'currentSettlement') {
            const typeName = riderInfo.acctApplyTypeName || '-';
            const date = formatSettlementDate(riderInfo.acctApplyDay);
            return date !== '-' ? `${typeName} (${date})` : typeName;
        }
        if (key === 'nextSettlement') {
            const typeName = riderInfo.nextAcctApplyTypeName || '-';
            const date = formatSettlementDate(riderInfo.nextAcctApplyDay);
            return date !== '-' ? `${typeName} (${date})` : typeName;
        }
        const value = riderInfo[key as keyof RiderDetailInfo];
        return getDisplayValue(value as string | undefined);
    };

    const maxLen = Math.max(BASIC_INFO_LEFT_FIELDS.length, BASIC_INFO_RIGHT_FIELDS.length);

    return (
        <div className="section-margin">
            <div className="detail-card">
                <div className="detail-card-header">
                    <i className="fas fa-user card-icon" />
                    <h3 className="card-title">기본정보</h3>
                </div>
                <div className="info-table">
                    {Array.from({ length: maxLen }).map((_, i) => {
                        const leftField = BASIC_INFO_LEFT_FIELDS[i];
                        const rightField = BASIC_INFO_RIGHT_FIELDS[i];
                        return (
                            <div key={i} className="info-row">
                                <div className="info-label">{leftField?.label ?? ''}</div>
                                <div className={`info-value${leftField && SETTLEMENT_KEYS.has(leftField.key) ? ' settlement-value' : ''}`}>
                                    {leftField ? renderFieldValue(leftField.key) : ''}
                                </div>
                                <div className="info-label">{rightField?.label ?? ''}</div>
                                <div className={`info-value${rightField && SETTLEMENT_KEYS.has(rightField.key) ? ' settlement-value' : ''}`}>
                                    {rightField ? renderFieldValue(rightField.key) : ''}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BasicInfoSection;
